// extracted by mini-css-extract-plugin
module.exports = {"Main":"AppMenu_Main__3pgyt","Item":"AppMenu_Item__3okXf"};